import React, { useCallback, useMemo } from 'react'
import {cutSteps, getSetupCard} from '../../hooks/useSelector';
import { useConfigPathContext } from '../../providers/ConfigPathContextProvider';
import { useConfigStepsContext } from '../../providers/ConfigStepsContextProvider';
import './CrumbArrow.css'

 //-----------------  Static  -------------------------------------//
//                                                                //
const getStyleClass       = (type) => `crumbArrow ${type}`;
const getStyleUpperTail   = (type) => `upperTail ${type}`;
const getStyleLowerTail   = (type) => `lowerTail ${type}`;
const getStyleContent     = (type) => `crumbArrowContent ${type}`;
const getStyleUpperSpear  = (type) => `upperSpear ${type}`;
const getStyleLowerSpear  = (type) => `lowerSpear ${type}`;

  //                                                                //
 //-----------------  Component  ----------------------------------//
//                                                                //

// name .......: SetupCard Only - it's the STEP-ID e.g: apps, rels, etc..
// children ...: Setup Wizard Only - The Display Title at the ControlBar Blue Crumbs, each display the selected SubFolder in the SetupCard like "Factory Settings" which is the selected under the cfgs Card.

// path .......: Full configPath to navigate when clicked.
// type .......: path   - means brown config path 
//               config - means blue Setup Wizard crumbs in the ControlBar
// isFirst ....: How to draw - First crumb: [==>>  the rest: >===>
const CrumbArrow = ({children, name, path, type='path', isFirst=false}) => {
  const {setConfigPath}     = useConfigPathContext();
  const {configSteps, setConfigSteps}       = useConfigStepsContext();
  const workPath = useMemo(() => path ? path : getSetupCard(name).getPath(configSteps), [configSteps, name, path]);
//  const ROOT = 'root';

  //
  // ------  Crumb Click  ------
  //
  const handleClick = useCallback(() => {
    // TODO: Only up to Root.  Otherwise irrelevant. so should be:  isRootOrAbove    
    setConfigPath(workPath);
    setConfigSteps(prev => {
        const next = {...prev};
        cutSteps(next, name);
        return next;
    });    

    // if (type === crumbType_Path) {
    //   // if (name === ROOT) {
    //   //   setConfigPath(configRootFolder);
    //   // }
    //   // else {
    //   //   setConfigPath(path);
    //   // }
    // }
    // else if (type === crumbType_Config) {
    //   setConfigPath(path);
    //   if (isConfigStep(name)) {
    //     setConfigPath(configRootFolder);
    //   }
    // }
    // else {
    //   console.error('UNKNOWN CRUMB TYPE: '+type);
    // }
  }, [name, setConfigPath, setConfigSteps, workPath]);


  const styleClass       = useMemo( ()=> getStyleClass(type), [type]);
  const styleUpperTail   = useMemo( ()=> getStyleUpperTail(type), [type]);
  const styleLowerTail   = useMemo( ()=> getStyleLowerTail(type), [type]);
  const styleContent     = useMemo( ()=> getStyleContent(type), [type]);
  const styleUpperSpear  = useMemo( ()=> getStyleUpperSpear(type), [type]);
  const styleLowerSpear  = useMemo( ()=> getStyleLowerSpear(type), [type]);

  return (
    <div className={styleClass} onClick={handleClick}>

      {!isFirst && 
      <div className='tail'>
        <div className={styleUpperTail}>&nbsp;</div>
        <div className={styleLowerTail}>&nbsp;</div>
      </div>}

      <div className={styleContent}>
        {children}
      </div>

      <div className='spear'>
        <div className={styleUpperSpear}>&nbsp;</div>
        <div className={styleLowerSpear}>&nbsp;</div>
      </div>

    </div>
  )
}

export default React.memo(CrumbArrow);